export const GET_JUMPSTART_LIST = 'GET_JUMPSTART_LIST';
export const SET_JUMPSTART_LIST = 'SET_JUMPSTART_LIST';
export const OPEN_JUMPSTART_MODAL = 'OPEN_JUMPSTART_MODAL';
export const CLOSE_JUMPSTART_MODAL = 'CLOSE_JUMPSTART_MODAL';
export const SORT_JUMPSTART_BOX = 'SORT_JUMPSTART_BOX';


// WEBPACK FOOTER //
// ./src/types/dashboardActionTypes.js